import { useAppSelector } from "../../Redux/store"
import { ButtonActionResolver } from "../Resolvers/ButtonActionResolver"
import { ActionButton } from "./ActionButton";

export const ActionButtons = () => {
    const { screen } = useAppSelector(state => state.screenInteractions);

    return (
            <div className="relative h-108 w-108">
                <ButtonActionResolver button="x" screen={screen}>
                    <ActionButton button="x" />
                </ButtonActionResolver>
                <ButtonActionResolver button="z" screen={screen}>
                    <ActionButton button="z" />
                </ButtonActionResolver>
        </div>
    )
}